import { render, staticRenderFns } from "./ListadoParcelasVendidas.vue?vue&type=template&id=abb96110"
import script from "./ListadoParcelasVendidas.vue?vue&type=script&lang=js"
export * from "./ListadoParcelasVendidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports